<script lang="ts">
  import properties from "$lib/properties";
  import { userStore } from "$lib/stores/user";
  import client from "$lib/utils/http/client";
  import {
    Avatar,
    Dropdown,
    DropdownHeader,
    DropdownItem,
  } from "flowbite-svelte";

  async function logout() {
    await client.instance
      .get(`${properties.serverUrl}/api/users/logout`)
      .catch(() => undefined);
    await userStore.logout();
  }
</script>

{#if $userStore}
  <div class="flex items-center md:order-2 cursor-pointer">
    <Avatar
      data-testid="dti-avatar-menu"
      id="avatar-menu"
      src={$userStore.avatarUrl}
    />
  </div>
  <Dropdown placement="bottom" triggeredBy="#avatar-menu">
    <DropdownHeader>
      <span class="block text-sm"
        >{$userStore.firstName} {$userStore.lastName}</span
      >
      <span class="block truncate text-sm font-medium">
        {$userStore.email}
      </span>
    </DropdownHeader>
    <DropdownItem data-testid="dti-logout-btn" on:click={logout}
      >Sign out
    </DropdownItem>
  </Dropdown>
{/if}
